import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 375-equals
 * @see {GlyphIcon}
 */
const EqualsIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M26,11v3a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H25A1,1,0,0,1,26,11Zm-1,7H7a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H25a1,1,0,0,0,1-1V19A1,1,0,0,0,25,18Z";
	}
}

export default EqualsIcon;
